// GLOBAL APP STATE
export const RESET_APP_STATE = 'RESET_APP_STATE';

// GET AND SAVE CASES
export const GET_PATHOLOGISTS_SUCCESS = 'GET_PATHOLOGISTS_SUCCESS';
export const GET_CASES_SUCCESS = 'get_cases_success';
export const NEW_CASE_SAVED = 'new_case_saved';
export const CREATE_CASE = 'create_case';
export const UPDATE_CASE_SUCCESS = 'update_case_success';
export const REFRESH_CASES_SUCCESS = 'refresh_cases_success';
export const DELETE_CASE_SUCCESS = 'delete_case_success';
export const ACTIVATE_CASE_SUCCESS = 'activate_case_success';
export const CONFIRM_CASE_GENERAL_PRISTINE = 'confirm-case-general-pristine';
export const CONFIRM_CASE_LEVEL_PRISTINE = 'confirm-case-level-pristine';
export const UPDATE_CASE = 'UPDATE_CASE';

export const SAVE_TEMP_CASE_LEVEL = 'save-temp-case';
export const SAVE_TEMP_CLINICAL_INFO = 'save-temp-clinical';
export const CASE_SELECT = 'case_select';
export const CASE_PART_SELECT = 'case_part_select';

export const SPECIMEN_SELECT = 'specimen_select';

export const SHOW_FORM = 'SHOW_FORM';

// SAVE PATHOLOGIST ASSIGNMENTS
export const SAVE_TEMP_PATHOLOGISTS_TO_ASSIGN = 'SAVE_TEMP_PATHOLOGISTS_TO_ASSIGN';
export const SAVE_TEMP_PATHOLOGISTS_TO_UNASSIGN = 'SAVE_TEMP_PATHOLOGISTS_TO_UNASSIGN';
export const REMOVE_TEMP_PATHOLOGISTS_TO_ASSIGN = 'REMOVE_TEMP_PATHOLOGISTS_TO_ASSIGN';
export const REMOVE_TEMP_PATHOLOGISTS_TO_UNASSIGN = 'REMOVE_TEMP_PATHOLOGISTS_TO_UNASSIGN';
export const UPDATE_ASSIGNED_PATHOLOGISTS_SUCCESS = 'UPDATE_ASSIGNED_PATHOLOGISTS_SUCCESS';
export const CLEAR_TEMP_PATHOLOGIST_ASSIGNMENT = 'CLEAR_TEMP_PATHOLOGIST_ASSIGNMENT';
export const CLEAR_ASSIGNED_PATHOLOGISTS = 'CLEAR_ASSIGNED_PATHOLOGISTS';

// AUTHENTICATION
export const LOGIN_USER = 'login_user';
export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAIL = 'login_user_fail';
export const VERIFY_TOKEN_START = 'VERIFY_TOKEN_START';
export const VERIFY_TOKEN_SUCCESS = 'VERIFY_TOKEN_SUCCESS';
export const VERIFY_TOKEN_FAIL = 'VERIFY_TOKEN_FAIL';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

// SPECIMENS
export const GET_VALIDATION_SPECIMENS = 'GET_VALIDATION_SPECIMENS';
export const GO_TO_NEXT = 'GO_TO_NEXT';
export const ADD_SPECIMEN = 'add_specimen';
export const UPDATE_SPECIMEN_FIELD = 'update_specimen_field';
export const UPLOAD_SPECIMEN_IMAGE = 'UPLOAD_SPECIMEN_IMAGE';
export const DELETE_SPECIMEN_IMAGE = 'DELETE_SPECIMEN_IMAGE';
export const GET_SPECIMENS_SUCCESS = 'get_specimens_success';
export const SAVE_SPECIMENS_SUCCESS = 'save_specimens_success';
export const UPDATE_SPECIMEN_TABLE = 'UPDATE_SPECIMEN_TABLE';
export const REFRESH_SEADRAGON = 'refresh_seadragon';
export const UPDATE_SPECIMEN_TEMP = 'update-specimen-temp';
export const PLOT_SPECIMEN_LOCATION = 'plot_specimen_location';
export const REFRESH_SPECIMENS_SUCCESS = 'REFRESH_SPECIMENS_SUCCESS';
export const TOGGLE_PORTAL = 'toggle_portal';
export const UPDATE_PORTAL_VALUES = 'update-portal-values';
export const ASSIGN_SNAPSHOTS = 'assign-snapshots';
export const CONFIRM_SPECIMEN_FORM_PRISTINE = 'confirm-form-pristine';
export const SPECIMEN_TABLE_HAS_CHANGED = 'SPECIMEN_TABLE_HAS_CHANGED';
export const SPECIMEN_ROW_HAS_CHANGED = 'SPECIMEN_ROW_HAS_CHANGED';
export const RESET_SPECIMEN_ROW_HAS_CHANGED = 'RESET_SPECIMEN_ROW_HAS_CHANGED';
export const SELECT_PATHOLOGIST = 'SELECT_PATHOLOGIST';
export const UPDATE_SPECIMEN = 'UPDATE_SPECIMEN';
export const UPDATE_ANALYSIS = 'UPDATE_ANALYSIS';
export const GO_TO_HOME = 'GO_TO_HOME';
export const UPDATE_ANALYSIS_WHEN_OPENING_OR_CLOSING_PORTAL = 'UPDATE_ANALYSIS_WHEN_OPENING_OR_CLOSING_PORTAL';
export const UPDATE_CADESS_IMAGE = 'UPDATE_CADESS_IMAGE';

export const CHECK_ALL_FORMS_VALIDITY = 'CHECK_ALL_FORMS_VALIDITY';

// OPENSEADRAGON
export const SET_OSG_BOUNDS = 'SET_OSG_BOUNDS';
export const STORE_ROTATION_ANGLE_OF_SPECIMEN_IMAGE = 'STORE_ROTATION_ANGLE_OF_SPECIMEN_IMAGE';
export const TOGGLE_CADESS_OVERLAY = 'TOGGLE_CADESS_OVERLAY';

// SNAPSHOT
export const SELECT_SNAPSHOT = 'select_snapshot';
export const ACTIVATE_SNAPSHOT = 'activate_snapshot';
export const DEACTIVATE_SNAPSHOT = 'deactivate_snapshot';
export const SAVE_SNAPSHOT = 'save_snapshot';
export const TEMP_SNAPSHOT = 'temp_snapshot';
export const GET_SNAPSHOTS_SUCCESS = 'get_snapshots_success';
export const CLEAR_SNAPSHOT_LIST = 'clear_snapshot_list';
export const DELETE_SNAPSHOT = 'delete_snapshot';
export const SHOW_SNAPSHOT = 'SHOW_SNAPSHOT';

// export const SNAPSHOT_NOTE = 'snapshot_note';

// DISPLAY WRAPPER
export const DISPLAY_WRAPPER = 'display_wrapper';

// NOTIFICATIONS
export const NOTIFICATION = 'NOTIFICATION';
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION';

// CADESS DATA
export const SET_CADESS_DATA = 'SET_CADESS_DATA';
export const CLEAR_CADESS_DATA = 'CLEAR_CADESS_DATA';

// CONFIRM MODAL
export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const HIDE_CONFIRM_MODAL = 'HIDE_CONFIRM_MODAL';
export const FLAG_UNSAVED_TABS = 'FLAG_UNSAVED_TABS';
export const SHOW_TABS = 'show-tabs';
export const FLAG_GENERAL = 'flag-general';
export const FLAG_CASE_LEVEL = 'flag-case-level';
export const FLAG_SPECIMEN = 'flag-specimen';

// FORM //todo move all form related types here
export const STORE_UNSAVED_ANALYSIS = 'STORE_UNSAVED_ANALYSIS';
export const REMOVE_STORED_UNSAVED_ANALYSIS = 'REMOVE_STORED_UNSAVED_ANALYSIS';

